import { useMutation } from '@tanstack/react-query';
import { reportError as reportErrorApi } from '../services/common/apiCommon';
import { useError } from '../context/ErrorContext';

export function useReportError() {
    const { handleErrorAction } = useError();
    const mutation = useMutation({
        mutationFn: (userData: FormData) => reportErrorApi(userData),
        onError: (error: Error) => {
            handleErrorAction(error)
        }
    });

    return mutation;
}